import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { IoIosCloseCircle } from "react-icons/io";
import { FaEdit, FaSave, FaTimes, FaIdCard, FaPercentage, FaCalendarAlt, FaImage } from 'react-icons/fa';
import { MdLocalOffer, MdCategory, MdDescription } from 'react-icons/md';
import { useMyContext } from '../../../context/MyContext';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Base_Url, updateOffer } from '../../../config/config';

const ViewOffer = ({ isopen, onClose, offer }) => {
    const { isDarkMode } = useMyContext();
    const [isEditMode, setIsEditMode] = useState(false);
    const [isEditId, setIsEditId] = useState(true);
    const [imagePreview, setImagePreview] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        reset
    } = useForm();

    useEffect(() => {
        if (offer) {
            setValue('id', offer.id || '');
            setValue('coupon_code', offer.coupon_code || '');
            setValue('category', offer.category || '');
            setValue('discount_type', offer.discount_type || '');
            setValue('discount_value', offer.discount_value || '');
            setValue('description', offer.description || '');
            setValue('start_date', offer.start_date || '');
            setValue('end_date', offer.end_date || '');
            setValue('status', offer.status || '');
            setValue('created_at', offer.created_at || '');

            // Set image preview if exists
            if (offer.image) {
                setImagePreview(`${Base_Url}${offer.image}`);
            }
        }
    }, [offer, setValue]);

    const handleClose = () => {
        setIsEditMode(false);
        setIsEditId(true);
        setImagePreview(null);
        setSelectedImage(null);
        reset();
        onClose();
    };

    const handleEditToggle = () => {
        setIsEditMode(!isEditMode);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // const onSubmit = async (data) => {
    //     const token = localStorage.getItem("token");
    //     const cusid = localStorage.getItem("cus_id");

    //     // Debug: make sure your token exists

    //     try {
    //         // ✅ Convert YYYY-MM-DD → DD/MM/YYYY
    //         const formatDate = (dateStr) => {
    //             if (!dateStr) return "";
    //             const date = new Date(dateStr);
    //             const day = String(date.getDate()).padStart(2, "0");
    //             const month = String(date.getMonth() + 1).padStart(2, "0");
    //             const year = date.getFullYear();
    //             return `${day}/${month}/${year}`;
    //         };

    //         const startDateFormatted = formatDate(data.start_date);
    //         const endDateFormatted = formatDate(data.end_date);

    //         // ✅ Prepare FormData
    //         const formData = new FormData();
    //         formData.append("category", data.category);
    //         formData.append("discount_type", data.discount_type);
    //         formData.append("discount_value", data.discount_value);
    //         formData.append("description", data.description);
    //         formData.append("start_date", startDateFormatted);
    //         formData.append("end_date", endDateFormatted);

    //         if (selectedImage) {
    //             formData.append("image", selectedImage);
    //         }

    //         // ✅ Debug FormData
    //         for (let [key, value] of formData.entries()) {
    //         }

    //         // ✅ API URL
    //         const urlUpdate = `${Base_Url}${updateOffer}/${offer.id}`;

    //         // ✅ Call the API using Axios
    //         const response = await axios.post(urlUpdate, formData, {
    //             headers: {
    //                 "token": token, 
    //                 "cus_id": cusid,
    //             },
    //         });

    //         // ✅ Handle success / error
    //         if (response.data.status === "SUCCESS") {
    //             // Close dialog first to prevent z-index issues
    //             handleClose();

    //             // Show success message after dialog closes
    //             setTimeout(() => {
    //                 Swal.fire({
    //                     title: 'Success!',
    //                     text: response.data.message || 'Offer updated successfully',
    //                     icon: 'success',
    //                     confirmButtonColor: '#3085d6',
    //                 });
    //             }, 2000);

    //             setIsEditMode(false);
    //             // Optionally refresh the offers list here
    //         } else {
    //             handleClose();
    //             setTimeout(() => {
    //                 Swal.fire({
    //                     title: 'Error!',
    //                     text: response.data.message || 'Failed to update offer',
    //                     icon: 'error',
    //                     confirmButtonColor: '#d33',
    //                     customClass: {
    //                         container: 'swal-high-z-index'
    //                     }
    //                 });
    //             },2000)
    //         }
    //     } catch (error) {
    //         handleClose();
    //         console.error('Error updating offer:', error);
    //         Swal.fire({
    //             title: 'Error!',
    //             text: error.response?.data?.message || 'An error occurred while updating the offer',
    //             icon: 'error',
    //             confirmButtonColor: '#d33',
    //             customClass: {
    //                 container: 'swal-high-z-index'
    //             }
    //         });
    //     }
    // };



    const onSubmit = async (data) => {
        const token = localStorage.getItem("token");
        const cusid = localStorage.getItem("cus_id");

        try {
            // ✅ Convert YYYY-MM-DD → DD/MM/YYYY
            const formatDate = (dateStr) => {
                if (!dateStr) return "";
                const date = new Date(dateStr);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            const startDateFormatted = formatDate(data.start_date);
            const endDateFormatted = formatDate(data.end_date);

            // ✅ Prepare FormData
            const formData = new FormData();
            formData.append("category", data.category);
            formData.append("discount_type", data.discount_type);
            formData.append("discount_value", data.discount_value);
            formData.append("description", data.description);
            formData.append("start_date", startDateFormatted);
            formData.append("end_date", endDateFormatted);

            if (selectedImage) {
                formData.append("image", selectedImage);
            }

            // Debugging
            // for (let [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }

            const urlUpdate = `${Base_Url}${updateOffer}/${offer.id}`;

            // ✅ Call API using fetch()
            const response = await fetch(urlUpdate, {
                method: "POST",
                headers: {
                    "token": token,
                    "cus_id": cusid,
                //    'Content-Type': 'multipart/form-data',
                },
                body: formData,
            });

            const result = await response.json();

            // ✅ Handle response
            if (result.status === "SUCCESS") {
                handleClose();

                setTimeout(() => {
                    Swal.fire({
                        title: "Success!",
                        text: result.message || "Offer updated successfully",
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                    });
                }, 2000);

                setIsEditMode(false);
            } else {
                handleClose();
                setTimeout(() => {
                    Swal.fire({
                        title: "Error!",
                        text: result.message || "Failed to update offer",
                        icon: "error",
                        confirmButtonColor: "#d33",
                        customClass: {
                            container: "swal-high-z-index",
                        },
                    });
                }, 2000);
            }
        } catch (error) {
            handleClose();
            console.error("Error updating offer:", error);
            Swal.fire({
                title: "Error!",
                text: "An error occurred while updating the offer",
                icon: "error",
                confirmButtonColor: "#d33",
                customClass: {
                    container: "swal-high-z-index",
                },
            });
        }
    };


    const onErrors = (errors) => {
        console.log('Form Errors:', errors);
    };

    if (!offer) return null;

    return (
        <Dialog
            open={isopen}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                className: "rounded-lg overflow-hidden"
            }}
        >
            <DialogTitle className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white relative shadow-custom-light dark:shadow-custom-dark">
                <h2 className="text-xs sm:text-xs font-bold text-white font-sans flex items-center">
                    <MdLocalOffer className="mr-3" size={16} />
                    Offer Details
                </h2>
                <IoIosCloseCircle
                    className="absolute top-3 right-3 cursor-pointer hover:scale-110 transition-transform"
                    size={16}
                    onClick={handleClose}
                />
            </DialogTitle>

            <DialogContent className="bg-white dark:bg-darkmodeColor dark:text-white custom-scrollbar" style={{ maxHeight: '75vh' }}>
                <div className="p-6 bg-white dark:bg-darkmodeColor dark:text-white shadow-custom-light dark:shadow-custom-dark rounded-custom">
                    <form className="space-y-8 font-sans" onSubmit={handleSubmit(onSubmit, onErrors)}>

                        {/* Primary Information Section */}
                        <div className="bg-purple-50 dark:bg-darkmodeColor dark:text-white p-4 rounded-custom border-l-4 border-purple-500">
                            <h3 className="text-lg font-bold mb-4 text-purple-700 dark:text-white flex items-center">
                                <FaIdCard className="mr-2" />
                                Primary Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom dark:shadow-custom-dark shadow-custom-light">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Offer ID</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('id')}
                                        disabled={isEditId}
                                    />
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom dark:shadow-custom-dark shadow-custom-light">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Coupon Code</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('coupon_code')}
                                        disabled={true}
                                    />
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Created At</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('created_at')}
                                        disabled={true}
                                    />
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Status</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('status')}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Offer Details Section */}
                        <div className="bg-blue-50 dark:bg-darkmodeColor dark:text-white p-4 rounded-custom border-l-4 border-blue-500">
                            <h3 className="text-lg font-bold mb-4 text-blue-700 dark:text-white flex items-center">
                                <MdCategory className="mr-2" />
                                Offer Details
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Category</label>
                                    <select
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('category', { required: 'Category is required' })}
                                        disabled={!isEditMode}
                                    >
                                        <option value="">Select Category</option>
                                        <option value="All">All</option>
                                        <option value="first Shipment">First Shipment</option>
                                        <option value="Returning Customer">Returning Customer</option>
                                    </select>
                                    {errors.category && <p className="text-red-500 text-sm mt-1">{errors.category.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Discount Type</label>
                                    <select
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('discount_type', { required: 'Discount type is required' })}
                                        disabled={!isEditMode}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="Flat">Flat</option>
                                        <option value="Percentage">Percentage</option>
                                    </select>
                                    {errors.discount_type && <p className="text-red-500 text-sm mt-1">{errors.discount_type.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Discount Value</label>
                                    <input
                                        type="number"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('discount_value', {
                                            required: 'Discount value is required',
                                            min: { value: 0, message: 'Value must be positive' }
                                        })}
                                        disabled={!isEditMode}
                                    />
                                    {errors.discount_value && <p className="text-red-500 text-sm mt-1">{errors.discount_value.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Description</label>
                                    <input
                                        type="text"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('description')}
                                        disabled={!isEditMode}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Date Information Section */}
                        <div className="bg-green-50 dark:bg-darkmodeColor p-4 rounded-custom border-l-4 border-green-500">
                            <h3 className="text-lg font-bold mb-4 text-green-700 dark:text-green-300 flex items-center">
                                <FaCalendarAlt className="mr-2" />
                                Validity Period
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Start Date</label>
                                    <input
                                        type="date"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('start_date', { required: 'Start date is required' })}
                                        disabled={!isEditMode}
                                    />
                                    {errors.start_date && <p className="text-red-500 text-sm mt-1">{errors.start_date.message}</p>}
                                </div>

                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">End Date</label>
                                    <input
                                        type="date"
                                        className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                        {...register('end_date', { required: 'End date is required' })}
                                        disabled={!isEditMode}
                                    />
                                    {errors.end_date && <p className="text-red-500 text-sm mt-1">{errors.end_date.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Image Section */}
                        <div className="bg-yellow-50 dark:bg-darkmodeColor p-4 rounded-custom border-l-4 border-yellow-500">
                            <h3 className="text-lg font-bold mb-4 text-yellow-700 dark:text-yellow-300 flex items-center">
                                <FaImage className="mr-2" />
                                Offer Image
                            </h3>

                            <div className="grid grid-cols-1 gap-6">
                                <div className="bg-white dark:bg-darkmodeColor dark:text-white p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                                    {imagePreview && (
                                        <div className="mb-4">
                                            <img
                                                src={imagePreview}
                                                alt="Offer preview"
                                                className="max-h-48 w-auto mx-auto rounded-lg shadow-md"
                                            />
                                        </div>
                                    )}

                                    {isEditMode && (
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Upload New Image</label>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                                            />
                                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">Supported formats: JPG, PNG, JPEG</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex space-x-4 mt-8">
                            <button
                                type="button"
                                onClick={handleEditToggle}
                                className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-3 px-6 rounded-custom hover:from-purple-700 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 font-medium transition-colors flex items-center dark:shadow-custom-dark shadow-custom-light"
                            >
                                {isEditMode ? (
                                    <>
                                        <FaTimes className="mr-2" /> Cancel Editing
                                    </>
                                ) : (
                                    <>
                                        <FaEdit className="mr-2" /> Edit Offer
                                    </>
                                )}
                            </button>

                            {isEditMode && (
                                <button
                                    type="submit"
                                    className="bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-6 rounded-custom hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 font-medium transition-colors flex items-center dark:shadow-custom-dark shadow-custom-light"
                                >
                                    <FaSave className="mr-2" /> Save Changes
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ViewOffer;